import React, { useEffect, useState } from "react";
import { message, Table, Modal, Input } from "antd";
import { get, buildQuery } from "../../api/axios";
import { formatAmount } from "../../utils/money";
import { Pagination } from "antd";
import SearchBar from "../../utils/SearchBar";
import { axiosApi1 as multipartAxios } from "../../api/axios"; // named export for file upload
import { baseUrl } from "../../api/axios";
import { useRef } from "react";

// أزرار الفلترة. كل فلتر يعرّف البارامترات التي تُرسل للـ backend.
// ⚠️ أسماء البارامترات (status / reservation_source / has_deposit / is_transferred)
// مبنية على تسمية الـ backend الحالية في `properties?status=`؛ إن اختلفت لدى
// فريق الـ backend فالتعديل هنا فقط — لا حاجة لتغيير أي شيء آخر في الملف.
const RESERVATION_FILTERS = [
  { key: "all", label: "الكل", className: "btn-dark", params: {} },
  {
    key: "confirmed",
    label: "المؤكد",
    className: "btn-success",
    params: { status: "confirmed" },
  },
  {
    key: "canceled",
    label: "الملغي",
    className: "btn-danger",
    params: { status: "canceled" },
  },
  {
    key: "ended",
    label: "المنتهي",
    className: "btn-secondary",
    params: { status: "ended" },
  },
  {
    key: "pending",
    label: "قيد الانتظار",
    className: "btn-warning text-white",
    params: { status: "pending" },
  },
  {
    key: "makan",
    label: "حجوزات مكان",
    className: "btn-outline-primary",
    params: { reservation_source: "user" },
  },
  {
    key: "has_deposit",
    label: "يوجد إيداع",
    className: "btn-outline-dark",
    params: { has_deposit: 1 },
  },
  {
    key: "transferred",
    label: "تم التحويل",
    className: "btn-outline-success",
    params: { is_transferred: 1 },
  },
];

const Reservations = () => {
  const getBaseFileUrl = () => {
    return baseUrl.replace("/api/admin/", "/");
  };

  const fileInputRef = useRef(null);

  const columns = [
    //1
    //بيانات الحجز
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الحجز
          </strong>
          <br />
          رقم الحجز
          <br />
          حالة الحجز <br />
          مصدر الحجز
          <br />
          جهة الحجز
          <br />
          تاريخ إنشاء الحجز
          <br />
          وقت إنشاء الحجز
          <br />
          كود الوحدة
          <br />
          سياسة الإلغاء
        </>
      ),
      render: ({
        id,
        status,
        reservation_source,
        date_of_creation,
        time_of_creation,
        reservation_os,
        cancellation_policy,
        property,
      }) => (
        <>
          {id || "-"} <br />
          {status || "-"} <br />
          {reservation_source === "user" ? "مكان" : "مضيف"} <br />
          {reservation_os || "-"} <br />
          {date_of_creation || "-"}
          <br /> {time_of_creation || "-"} <br />
          {property?.id ? `U${property?.id}` : "-"}
          <br />
          {cancellation_policy || "-"}
        </>
      ),
    },

    //2
    //بيانات الاقامة
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الإقامة
          </strong>
          <br />
          اسم الوحدة
          <br />
          المدينة
          <br />
          الحي <br />
          تاريخ الوصول
          <br />
          تاريخ المغادرة
          <br />
          وقت الوصول
          <br />
          وقت المغادرة
          <br />
          مدة الإقامة
        </>
      ),
      render: ({ arrives_leaves, daysNumbers, property }) => {
        const splitDateRange = (date) => {
          if (!date || typeof date !== "string") {
            return { from: "-", to: null };
          }

          const parts = date.split(" - ");

          return {
            from: parts[0],
            to: parts[1] || null,
          };
        };

        const { from, to } = splitDateRange(arrives_leaves?.date);

        return (
          <div>
            {property?.name || "-"}
            <br />
            {property?.city || "-"}
            <br />
            {property?.district || "-"}
            <br />
            {from}
            {to && <div>{to}</div>}

            {arrives_leaves?.arriving_time || "-"}
            <br />
            {arrives_leaves?.leaving_time || "-"}
            <br />
            {daysNumbers || "-"}
          </div>
        );
      },
    },

    //3
    //بيانات الضيف والمضيف
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الضيف والمضيف
          </strong>
          <br />
          اسم الضيف
          <br />
          البريد الإلكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
          اسم المضيف
          <br />
          البريد الإلكتروني
          <br />
          الجوال
          <br />
          رقم المضيف
          <br />
        </>
      ),
      render: ({ user, owner }) => (
        <>
          {user?.name || "-"} <br />
          {user?.email || "-"} <br />
          {user?.phone || "-"} <br />
          {user?.id ? `G${user?.id}` : "-"} <br />
          {owner?.name || "-"} <br />
          {owner?.email || "-"} <br />
          {owner?.phone || "-"} <br />
          {owner?.id ? `H${owner?.id}` : "-"}
        </>
      ),
    },

    //4
    // بيانات السعر
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات السعر
          </strong>
          <br />
          طريقة السداد
          <br />
          المدة * سعر الليلة
          <br />
          إجمالي السعر
          <br />
          العرض
          <br />
          كود خصم
          <br />
          مبلغ الحجز
          <br />
          رسوم الخدمة
          <br />
          المجموع
        </>
      ),

      render: ({
        prices,
        daysNumbers,
        total_price,
        payment_method,
        reservation_source,
      }) => (
        <>
          {reservation_source === "user" ? payment_method || "-" : "-"} <br />
          {reservation_source === "user"
            ? `${daysNumbers} * ${prices.avg_price}`
            : "-"}{" "}
          <br />
          {reservation_source === "user" ? prices.subTotal : "-"} <br />
          {reservation_source === "user" ? prices.offers_amount : "-"} <br />
          {reservation_source === "user" ? prices.coupon_amount : "-"} <br />
          {reservation_source === "user"
            ? prices.total_price_without_service
            : "-"}{" "}
          <br />
          {reservation_source === "user" ? prices.total_service : "-"} <br />
          {total_price} <br />
        </>
      ),
    },

    //5
    // تقييم الضيف للوحدة
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            تقييم الضيف للوحدة
          </strong>
          <br />
          تاريخ التقييم
          <br />
          التقييم العام
          <br />
          النظافة
          <br />
          الحالة
          <br />
          الخدمة
          <br />
          الجودة
          <br />
          التطابق
          <br />
          حالة التقييم
        </>
      ),
      render: ({ rate }) => (
        <>
          {rate && (
            <>
              {rate?.date || "-"} <br /> {rate?.total_rating || "-"} <br />{" "}
              {rate?.clean || "-"}
              <br /> {rate?.new || "-"} <br /> {rate?.service || "-"} <br />{" "}
              {rate?.pricing || "-"}
              <br /> {rate?.matching || "-"} <br />
            </>
          )}
        </>
      ),
    },

    //6
    //تقييم المضيف للضيف
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            تقييم المضيف للضيف
          </strong>
          <br />
          تاريخ الرد
          <br />
          التقييم العام
          <br />
          اللباقة
          <br />
          المحافظة
          <br />
          الحرص
          <br />
          الالتزام
          <br />
          الترحيب
          <br />
          حالة الرد
        </>
      ),
      render: ({ owner_rate }) => (
        <>
          {owner_rate && (
            <>
              {owner_rate.date || "-"} <br />
              {owner_rate.total_rating || "-"} <br />
              {owner_rate.clean || "-"} <br />
              {owner_rate.care || "-"} <br />
              {owner_rate.instructions || "-"} <br />
              {owner_rate.satisfaction || "-"} <br />
              {owner_rate.tact || "-"} <br />
            </>
          )}
        </>
      ),
    },

    // //7
    // // بيانات الإيداع
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الإيداع
          </strong>
          <br />
          المدفوع من الضيف
          <br />
          (رسوم الإيداع)
          <br />
          (ضريبة رسوم الإيداع)
          <br />
          (رسوم الإيداع شامل الضريبة)
          <br />
          مبلغ الإيداع
          <br />
          تاريخ الإيداع
          <br />
          السرد (الإيداع)
          <br />
          مرفق الإيداع
        </>
      ),
      render: ({ deposit }) => (
        <>
          {formatNumber(deposit?.paid_by_guest) || "-"} <br />
          {formatNumber(deposit?.deposit_fee) || "-"} <br />
          {formatNumber(deposit?.deposit_fee_tax) || "-"} <br />
          {formatNumber(deposit?.deposit_fee_with_tax) || "-"} <br />
          {formatNumber(deposit?.deposit_amount) || "-"} <br />
          {formatDateOnly(deposit?.deposit_date)} <br />
          {deposit?.span_card || "-"} <br />
          {deposit?.attachment ? (
            <a
              href={
                deposit.attachment?.startsWith("http")
                  ? deposit.attachment
                  : `${getBaseFileUrl()}storage/${deposit.attachment}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              عرض
            </a>
          ) : (
            "-"
          )}
        </>
      ),
    },

    //      بيانات الفاتورة
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الفاتورة
          </strong>
          <br />
          تاريخ فاتورة الضيف
          <br />
          رقم فاتورة الضيف
          <br />
          عرض فاتورة الضيف
          <br />
          فاتورة الضيف PDF
          <br />
          تاريخ فاتورة المضيف
          <br />
          رقم فاتورة المضيف
          <br />
          عرض فاتورة المضيف
          <br />
          فاتورة المضيف PDF
          <br />
          إثبات عملية إيداع
        </>
      ),
      width: "200px",

      render: (_, record) => {
        const { user, owner } = record;

        return (
          <span>
            {user?.invoice?.created_at || "-"}
            <br />
            {user?.invoice?.number || "-"}
            <br />
            {user?.invoice?.invoice_path ? (
              <a
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
                href={user?.invoice?.invoice_path}
              >
                عرض فاتورة الضيف
              </a>
            ) : (
              "-"
            )}
            <br />
            <button
              className="btn btn-primary py-1 my-1"
              disabled={invoicePdfLoading === `${record.id}-user`}
              onClick={() => handleInvoicePdf(record.id, "user")}
            >
              {invoicePdfLoading === `${record.id}-user`
                ? "جاري التحضير..."
                : "فاتورة الضيف PDF"}
            </button>
            <br />
            {owner?.invoice?.created_at || "-"}
            <br />
            {owner?.invoice?.number || "-"}
            <br />
            {owner?.invoice?.invoice_path ? (
              <a
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
                href={owner?.invoice?.invoice_path}
              >
                عرض فاتورة المضيف
              </a>
            ) : (
              "-"
            )}
            <br />
            <button
              className="btn btn-primary py-1 my-1"
              disabled={invoicePdfLoading === `${record.id}-owner`}
              onClick={() => handleInvoicePdf(record.id, "owner")}
            >
              {invoicePdfLoading === `${record.id}-owner`
                ? "جاري التحضير..."
                : "فاتورة المضيف PDF"}
            </button>
            <br />
            <button
              className="btn btn-primary py-1"
              onClick={() => {
                setSelectedReservation(record.id);
                setSelectedRecord(record);

                const deposit = record.deposit || {};

                const spanCardGenerated = `B${record.id}-U${
                  record.property?.id || "-"
                }-G${record.user?.id || "-"}-H${record.owner?.id || "-"}`;

                const paid = parseFloat(extractNumber(record.total_price)) || 0;

                const feeWithTax =
                  parseFloat(deposit.deposit_fee_with_tax) || 0;

                setForm({
                  invoice_id: record.id,

                  paid_by_guest: extractNumber(record.total_price),

                  deposit_fee: deposit.deposit_fee ?? "",

                  deposit_fee_tax: deposit.deposit_fee_tax ?? "",

                  deposit_fee_with_tax:
                    deposit.deposit_fee_with_tax ??
                    (feeWithTax ? feeWithTax.toString() : ""),

                  deposit_amount:
                    deposit.deposit_amount ??
                    (paid - feeWithTax ? (paid - feeWithTax).toString() : ""),

                  deposit_date: formatDateForInput(deposit.deposit_date),

                  span_card: deposit.span_card ?? spanCardGenerated,

                  attachment: deposit.attachment ?? "",
                });

                setAttachmentFile(null);
                setOpenDepositModal(true);
              }}
            >
              إثبات إيداع
            </button>
          </span>
        );
      },
    },

    //8
    // بيانات الحوالة
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الحوالة
          </strong>
          <br />
          رقم الحوالة
          <br />
          حالة الحوالة
          <br />
          مبلغ التحويل
          <br />
          تاريخ الحوالة
          <br />
          مبلغ كود المنصة
          <br />
          كود المنصة
        </>
      ),
      render: (record) => {
        // نفس مصدر البيانات المستخدم في شاشتي الحوالات والمبيعات.
        // invoice_transfers قد يأتي كمصفوفة أو ككائن مفرد.
        const transfer = Array.isArray(record?.invoice_transfers)
          ? record.invoice_transfers[0]
          : record?.invoice_transfers;

        const payout = record?.payout;

        // رقم الحوالة: الرقم المرجعي للتحويل، وإلا معرّف الحوالة بصيغة TRN
        const payoutNumber =
          transfer?.reference_number ||
          payout?.number ||
          (payout?.id ? `TRN${payout.id}` : null);

        // إن وُجد تحويل منفّذ فالحالة "منفذة" حتى لو لم يرد payout_status
        const payoutStatus =
          payout?.payout_status || (transfer ? "منفذة" : null);

        const payoutAmount = transfer?.transfer_amount ?? payout?.amount;

        const payoutDate =
          transfer?.operation_date || payout?.paid_at || payout?.created_at;

        // كوبون المنصة: يُقرأ من record.coupon كما في شاشة الحوالات،
        // مع الرجوع إلى prices للتوافق مع الاستجابات الأقدم.
        const coupon = record?.coupon || record?.prices;
        const isMakanCoupon =
          coupon?.coupon_type === "MAKAN" && coupon?.coupon_amount != null;

        return (
          <>
            {/* رقم الحوالة */}
            {payoutNumber || "-"} <br />
            {/* حالة الحوالة */}
            {payoutStatus || "-"} <br />
            {/* مبلغ التحويل */}
            {formatAmount(payoutAmount)} <br />
            {/* تاريخ الحوالة */}
            {payoutDate || "-"} <br />
            {/* مبلغ كود المنصة */}
            {isMakanCoupon ? formatAmount(coupon.coupon_amount) : "-"} <br />
            {/* كود المنصة */}
            {isMakanCoupon ? coupon.coupon_code || "-" : "-"}
          </>
        );
      },
    },

    //9
    //بيانات الاسترداد
    {
      title: (
        <>
          <strong
            style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}
          >
            بيانات الاسترداد
          </strong>
          <br />
          رقم الاسترداد
          <br />
          مبلغ الاسترداد
          <br />
          تاريخ الاسترداد
        </>
      ),
      dataIndex: "",
    },

    //10

    // {
    //   title: <>الإيداع</>,
    //   render: (record) => (
    //     <button
    //       className="btn btn-primary py-1 mt-1"
    //       onClick={() => {
    //         setSelectedReservation(record.id);
    //         setOpenDepositModal(true);
    //       }}
    //     >
    //       الإيداع
    //     </button>
    //   ),
    // },
    //   {
    //   title: (
    //     <>
    //       بيانات الضيف
    //       <br />
    //       الاسم
    //       <br />
    //       الجوال
    //       <br />
    //       البريد الالكتروني
    //       <br />
    //       رقم الضيف
    //       <br />
    //     </>
    //   ),
    //   render: ({ user }) => (
    //     <>
    //       {/* رقم الضيف : {user.id} <br /> */}
    //       {user.name} <br />
    //       {user.phone} <br />
    //       {user.email} <br />
    //     </>
    //   ),
    // },
    // {
    //   title: "انشاء حوالة",
    //   render: ({
    //     id,
    //     reservation_source,
    //     total_price,
    //     status,
    //     has_payout,
    //     is_payable,
    //   }) => (
    //     <>
    //       {reservation_source === "user" && (
    //         // <button
    //         //   disabled={!has_payout & is_payable ? false : true}
    //         //   className="btn btn-outline-warning btn-sm p-0"
    //         // >
    //         //   <Link
    //         //     className="color-inherit text-decoration-none py-1 px-2 d-block"
    //         //     to={`/payouts/create/${id}`}
    //         //   >
    //         //     {!has_payout ? (
    //         //       <>
    //         //         <FileAddOutlined />
    //         //         انشاء
    //         //       </>
    //         //     ) : (
    //         //       <>تم انشاء حوالة بالفعل</>
    //         //     )}
    //         //   </Link>
    //         // </button>
    //         <button className="btn btn-outline-warning btn-sm p-0">
    //           <Link
    //             className="color-inherit text-decoration-none py-1 px-2 d-block"
    //             to={{
    //               pathname: `/payouts/create/${id}`,
    //               state: { amount: total_price },
    //             }}
    //           >
    //             <>
    //               <FileAddOutlined />
    //               انشاء
    //             </>
    //           </Link>
    //         </button>
    //       )}
    //     </>
    //   ),
    // },
  ];

  const [data, setData] = useState([]);

  const [openDepositModal, setOpenDepositModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [attachmentFile, setAttachmentFile] = useState(null);

  const [invoicePdfLoading, setInvoicePdfLoading] = useState(null);

  // فتح نافذة فورًا عند الضغط (قبل انتظار الـ API) حتى لا يحظرها المتصفح،
  // لأن أول استدعاء قد يتأخر لحين توليد الـ PDF في السيرفر
  const handleInvoicePdf = async (id, type) => {
    const key = `${id}-${type}`;
    setInvoicePdfLoading(key);
    const pdfWindow = window.open("", "_blank");
    try {
      const res = await get(`reservations/invoice-pdf/${id}/${type}`);
      if (res?.data?.url) {
        if (pdfWindow) {
          pdfWindow.location.href = res.data.url;
        } else {
          window.open(res.data.url, "_blank", "noopener,noreferrer");
        }
      } else {
        pdfWindow?.close();
        message.error("تعذر جلب فاتورة الـ PDF");
      }
    } finally {
      setInvoicePdfLoading(null);
    }
  };

  const [form, setForm] = useState({
    invoice_id: "",
    paid_by_guest: "",
    deposit_fee: "",
    deposit_fee_tax: "",
    deposit_fee_with_tax: "",
    deposit_amount: "",
    deposit_date: "",
    span_card: "",
    attachment: "",
  });

  // ✅ استخراج رقم من سترينغ (مثل 120 SAR)
  const extractNumber = (val) => {
    if (!val) return "";
    const match = val.toString().match(/(\d+(\.\d+)?)/);
    return match ? match[0] : val;
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleAttachmentChange = (e) => {
    const file = e.target.files[0];
    setAttachmentFile(file);
  };

  // ✅ ارسال الفورم
  const handleDepositSubmit = async () => {
    setConfirmLoading(true);
    try {
      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        if (key !== "attachment") {
          if (key === "deposit_date") {
            formData.append(key, form[key] ? formatDateForAPI(form[key]) : "");
          } else {
            formData.append(key, form[key] ?? "");
          }
        }
      });

      if (attachmentFile) {
        formData.append("attachment", attachmentFile);
      }

      await multipartAxios.post("reservation-deposits", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setConfirmLoading(false);
      message.success("تم إضافة الإيداع بنجاح");
      setOpenDepositModal(false);

      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }

      const res = await get(`reservations`);
      setData(res?.data.data || []);

      // setForm({
      //   invoice_id: "",
      //   paid_by_guest: "",
      //   deposit_fee: "",
      //   deposit_fee_tax: "",
      //   deposit_fee_with_tax: "",
      //   deposit_amount: "",
      //   deposit_date: "",
      //   span_card: "",
      //   attachment: "",
      // });
    } catch (err) {
      console.error(err);
      message.error("حدث خطأ أثناء الحفظ");
    } finally {
      setConfirmLoading(false);
      setAttachmentFile(null); // ✅ مهم
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);
  const [activeFilter, setActiveFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);

  const [total, setTotal] = useState(1);

  // نقطة الجلب الوحيدة: تجمع البحث + الفلتر + الصفحة في كل مرة،
  // حتى لا يضيع أي منها عند تغيير الآخر.
  const fetchReservations = (
    { page = 1, filterKey = activeFilter, search = searchQuery } = {},
  ) => {
    setLoading(true);
    const filter =
      RESERVATION_FILTERS.find((item) => item.key === filterKey) ||
      RESERVATION_FILTERS[0];

    return get(
      `reservations${buildQuery({ page, search, ...filter.params })}`,
    ).then((res) => {
      setData(res?.data?.data || []);
      if (res?.data?.meta?.last_page) {
        setTotal(res.data.meta.last_page);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    // البحث يعيدنا دائماً للصفحة الأولى
    setCurrentPage(1);
    fetchReservations({ page: 1, search: searchQuery });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  const handlePagination = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchReservations({ page: pageNumber });
  };

  const handleFilter = (filterKey) => {
    setActiveFilter(filterKey);
    setCurrentPage(1);
    fetchReservations({ page: 1, filterKey });
  };

  const formatDateOnly = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const formatDateForInput = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  // كانت هذه الدالة لا تفعل شيئاً (ترجع القيمة كما هي في الحالتين).
  // صارت تُوحّد المبالغ على خانتين عشريتين عبر الأداة المشتركة.
  const formatNumber = (val) => formatAmount(val);

  const formatDateForAPI = (date) => {
    if (!date) return "";

    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  // ✅ حساب الرسوم شامل الضريبة تلقائي
  useEffect(() => {
    const fee = parseFloat(form.deposit_fee) || 0;
    const tax = parseFloat(form.deposit_fee_tax) || 0;
    const total = fee + tax;

    setForm((prev) => ({
      ...prev,
      deposit_fee_with_tax: total ? total.toString() : "",
    }));
  }, [form.deposit_fee, form.deposit_fee_tax]);

  useEffect(() => {
    const paid = parseFloat(form.paid_by_guest) || 0;
    const feeWithTax = parseFloat(form.deposit_fee_with_tax) || 0;

    const result = paid - feeWithTax;

    setForm((prev) => ({
      ...prev,
      deposit_amount: result ? result.toString() : "",
    }));
  }, [form.paid_by_guest, form.deposit_fee_with_tax]);

  return (
    <div>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
        <div
          style={{ flex: "1 1 320px", minWidth: "260px", maxWidth: "420px" }}
        >
          <SearchBar
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
            debouncedValue={debouncedValue}
            setDebouncedValue={setDebouncedValue}
          />
        </div>
        <div className="d-flex flex-wrap gap-2 mb-3 ">
          {RESERVATION_FILTERS.map(({ key, label, className }) => (
            <button
              key={key}
              type="button"
              onClick={() => handleFilter(key)}
              disabled={loading}
              className={`btn btn-sm ${className} ${
                activeFilter === key ? "active fw-bold" : ""
              }`}
              style={
                activeFilter === key
                  ? { boxShadow: "0 0 0 2px rgba(0,0,0,.25)" }
                  : undefined
              }
            >
              {label}
            </button>
          ))}
        </div>
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              rowKey="id"
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                y: "65vh",
                x: 1650,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              current={currentPage}
              showSizeChanger={false}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        title={
          <div style={{ textAlign: "center", fontWeight: 600 }}>
            نموذج إثبات إيداع
          </div>
        }
        open={openDepositModal}
        onOk={handleDepositSubmit}
        confirmLoading={confirmLoading}
        onCancel={() => {
          setOpenDepositModal(false);
          setAttachmentFile(null);

          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
        }}
        width={800}
        okText="حفظ"
        cancelText="إغلاق"
        maskClosable={false}
        destroyOnClose
      >
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}
        >
          <div>
            <label>المدفوع من الضيف</label>
            <Input
              name="paid_by_guest"
              value={form.paid_by_guest}
              onChange={handleChange}
              readOnly
              placeholder="المدفوع من الضيف"
            />
          </div>

          <div>
            <label>مبلغ الإيداع</label>
            <Input
              name="deposit_amount"
              value={form.deposit_amount}
              onChange={handleChange}
              placeholder="مبلغ الإيداع"
            />
          </div>

          <div>
            <label>رسوم الإيداع</label>
            <Input
              name="deposit_fee"
              value={form.deposit_fee}
              onChange={handleChange}
              placeholder="رسوم الإيداع"
            />
          </div>

          <div>
            <label>تاريخ الإيداع</label>
            <Input
              type="date"
              name="deposit_date"
              value={form.deposit_date}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>ضريبة الرسوم</label>
            <Input
              name="deposit_fee_tax"
              value={form.deposit_fee_tax}
              onChange={handleChange}
              placeholder="ضريبة الرسوم"
            />
          </div>

          <div>
            <label>السرد</label>
            <Input
              name="span_card"
              value={form.span_card}
              onChange={handleChange}
              placeholder="السرد"
            />
          </div>

          <div>
            <label>الرسوم شامل الضريبة</label>
            <Input
              name="deposit_fee_with_tax"
              value={form.deposit_fee_with_tax}
              //  onChange={handleChange}
              placeholder="الرسوم شامل الضريبة"
            />
          </div>

          <div>
            <label>المرفق</label>

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* ✅ عرض المرفق الحالي */}
              {/* ✅ input */}
              <Input
                type="file"
                ref={fileInputRef}
                onChange={handleAttachmentChange}
              />
              {form.attachment && (
                <a
                  href={
                    form.attachment.startsWith("http")
                      ? form.attachment
                      : `${getBaseFileUrl()}storage/${form.attachment}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ whiteSpace: "nowrap" }}
                >
                  عرض
                </a>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Reservations;
